/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/import-whitelist
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import {
	getUserProperty,
	setUserProperties,
} from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import type { State } from './State.types.tsx';

type AccountId = string;

export const PROPERTY_KEY = 'jsm-queue-groups-state-selected-group-id';

export const setQueueGroupsStateInUserProperty = async (
	projectKey: string,
	value: State,
	accountId: AccountId,
): Promise<void> => {
	try {
		setUserProperties(accountId, `${PROPERTY_KEY}_${projectKey}`, JSON.stringify(value));
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			error,
			meta: {
				id: 'setQueueGroupsStateInUserPropertyError',
			},
		});
		throw error;
	}
};

export const getQueueGroupsStateFromUserProperty = async (
	projectKey: string,
	accountId: AccountId,
): Promise<State> => {
	try {
		return await getUserProperty<State>(accountId, `${PROPERTY_KEY}_${projectKey}`);
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			error,
			meta: {
				id: 'getQueueGroupsStateFromUserPropertyError',
			},
		});
		throw error;
	}
};
